import React, { useState, useEffect } from "react";

/** Component */
import {
  TableContainer,
  TableHead,
  TextField,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  TableFooter,
  ButtonGroup,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */

/** Api && Function */
import { getSyncTime, updateSyncTime, getFrttime } from "../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import moment from "moment";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useDispatch } from "react-redux";

const Synctime = () => {
  const location = useLocation();
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getSyncTime);
  const filter = convertQueryStringToObject(location.search);
  const [input, setInput] = useState({
    date: "",
    long: "",
  });
  const [convertData, setConvertData] = useState({
    date: "",
    long: "",
  });
  const [selectedRow, setSelectedRow] = useState(null);

  const handleConvert = () => {
    setConvertData({ date: "", long: "" });
    return getFrttime(input);
  };
  const handleConvertResponse = (res) => {
    // eslint-disable-next-line eqeqeq
    if (res.code == 200) setConvertData(res.data);
  };
  const handleUpdateResponse = (res) => {
    // eslint-disable-next-line eqeqeq
    setData((prev) => prev.map((i) => (i.id == res.data.id ? res.data : i)));
  };
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN THỜI GIAN ĐỒNG BỘ DỮ LIỆU"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40 }}></ButtonGroup>
      </div>
      <div
        style={{
          display: "grid",
          border: "1px solid var(--primary-color)",
          padding: 10,
          borderRadius: 8,
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
          gap: 10,
          margin: "0 auto 20px auto",
          maxWidth: 1000,
          alignItems: "center",
        }}
      >
        <div>Định dạng thời gian</div>
        <div>
          <CustomDatePicker label="Date" format="DD/MM/YYYY HH:mm" outputFormat="YYYY-MM-DD HH:mm:ss" value={input.date} onChange={(value) => setInput((prev) => ({ ...prev, date: value }))} />
        </div>
        <div>
          <TextField label="Long" value={input.long} onChange={(e) => setInput((prev) => ({ ...prev, long: e.target.value }))} />
        </div>
        <div>
          <ButtonWithAPICall disableSnackbar={(res) => res.code === 200} variant="outlined" api={handleConvert} response={handleConvertResponse}>
            Chuyển đổi
          </ButtonWithAPICall>
        </div>
        <div></div>
        <div>
          <svg style={{ visibility: convertData.long ? "" : "hidden" }} width="105px" height="30" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth={0} />
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path stroke="var(--primary-color)" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 2v16m0 0l-7-7m7 7l7-7" />{" "}
            </g>
          </svg>
        </div>
        <div>
          <svg style={{ visibility: convertData.date ? "" : "hidden" }} width="105px" height="30" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth={0} />
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path stroke="var(--primary-color)" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 2v16m0 0l-7-7m7 7l7-7" />{" "}
            </g>
          </svg>
        </div>
        <div></div>
        <div>Kết quả:</div>
        <div style={{ color: "var(--primary-color)" }}>{convertData.long}</div>
        <div style={{ color: "var(--primary-color)" }}>{convertData.date && dayjs(convertData.date).format("DD/MM/YYYY HH:mm")}</div>
      </div>
      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Bảng")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Thời gian đồng bộ")}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Người thực hiện")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data.map((row, index) => (
                  <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => setSelectedRow(row)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.table}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.sync_at && moment(row.sync_at).format("DD/MM/YYYY HH:mm")}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.username}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditDialog open={Boolean(selectedRow)} onClose={() => setSelectedRow(null)} onSuccess={handleUpdateResponse} initialData={selectedRow} />
    </div>
  );
};

export default Synctime;

const EditDialog = ({ open, onClose, onSuccess, initialData }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState(initialData);

  useEffect(() => {
    setInputData(initialData);
  }, [initialData]);
  const handleSave = () => {
    return updateSyncTime(initialData.id, {
      sync_at: moment(inputData.sync_at).format("YYYY-MM-DD HH:mm:ss"),
    });
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      onSuccess && onSuccess(res);
    }
  };
  if (inputData)
    return (
      <Dialog open={open} onClose={onClose} align="center">
        <DialogTitle>{t("Chỉnh sửa thời gian đồng bộ dữ liệu")}</DialogTitle>
        <DialogContent style={{ paddingTop: 10 }}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Thời gian đồng bộ")}
            value={inputData.sync_at}
            onChange={(value) => setInputData((prev) => ({ ...prev, sync_at: value }))}
            sx={{ margin: "5px 0", width: "100%" }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("Hủy")}</Button>
          <ButtonWithAPICallComponent variant="contained" api={handleSave} response={handleResponse}>
            {t("Lưu")}
          </ButtonWithAPICallComponent>
        </DialogActions>
      </Dialog>
    );
  else return "";
};
